import React from 'react'

import classnames from 'classnames'

import { RecipeCustomisationPricing } from '@library/api-menu-experience/src/interfaces/recipe'

import css from './RecipeOptionsItem.css'

type ItemContentProps = {
  recipeName: string
  pricing?: RecipeCustomisationPricing
  isOutOfStock: boolean
  isChecked?: boolean
}

const ExtraInformation = ({
  isOutOfStock,
  pricing,
}: Pick<ItemContentProps, 'isOutOfStock' | 'pricing'>) => {
  if (isOutOfStock) {
    return <span className={css.soldOutText}>Sold out</span>
  }

  if (pricing?.perPortionSurcharge) {
    return (
      <div className={classnames(css.extraInformation, css.negativeMargin)}>
        <span className={css.surchargeText}>{pricing.perPortionSurcharge}</span>
      </div>
    )
  }

  return null
}
export const RecipeOptionsItemContent = ({
  recipeName,
  isOutOfStock,
  pricing,
  isChecked,
}: ItemContentProps) => (
  <div className={css.labelContainer}>
    <div className={css.titleContainer}>
      <span
        className={classnames({
          [css.titleTextActive]: isChecked,
          [css.titleText]: !isChecked,
        })}
      >
        {recipeName}
      </span>
    </div>
    <ExtraInformation isOutOfStock={isOutOfStock} pricing={pricing} />
  </div>
)
